import { FunctionComponent, HTMLProps } from 'react'
import useWhiteBg from 'hooks/use-white-bg'
import CONFIGS from 'build/Config'
import { ButtonInit } from '../../theme/theme'

interface IButton {
  className: string
  disabled: boolean
  variant?: string
}

const Button: FunctionComponent<Omit<HTMLProps<HTMLButtonElement>, 'type'>> = ({
  className,
  disabled,
  variant,
  ...props
}: IButton) => {
  const { shouldUseWhiteBg } = useWhiteBg()

  const componentClass = CONFIGS?.versionPh
    ? `${className} button-generic ${variant ?? ''}`
    : `${className} p-4 min-h-2 w-full mx-auto rounded-none din font-bold uppercase ${disabled && 'border-2'} button-generic`.trim()

  return <ButtonInit className={componentClass} {...props} disabled={disabled} shouldUseWhiteBg={shouldUseWhiteBg} />
}

export default Button
